import { Component, OnInit, OnDestroy } from '@angular/core';

import { DataComponent} from '../constant/data.component';
import { ActivatedRoute, Router } from '@angular/router';

import * as _ from 'lodash';
import { ApiAwards } from '../config/api.component';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'exq-nominee',
  templateUrl: './nominee.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class NomineeComponent implements OnInit, OnDestroy {
  updateTime = Date.now();
  listArray: any;
  listArrayAds: any;
  listTotalVoter: any;
  pagingList: any;
  pagingAds: any;
  currentCat: number;
  currentCatID: any;
  typeCat: number; // 1 for reader choice &  0 for normal category
  currentSelected = 0;
  tempArraySubmit: Array<any> = [];
  tempArrayReader: Array<any> = [];
  sub: any;
  finishGetData = true;
  dataCity = [];
  expCounter: number = 0;
  currentTime: number = Date.now();

  constructor(private api: ApiAwards, public dataComponent: DataComponent, private route: ActivatedRoute, public snackBar: MatSnackBar, private router: Router) {
    this.api.getCounters().subscribe(
      val => {

        this.expCounter = val.json().data.exp_counter;
        // console.log(this.expCounter);
      },
      error => {
        // console.log(error);
      },
      () => { }
    );
  }

  dynamicSort(property) {
    console.log(property)
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers, 
      * and you may want to customize it to your needs
      */
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      console.log(result)
      return result * sortOrder;
    }
  }

  ngOnInit() {
    this.tempArraySubmit = this.dataComponent.dataTemp;

    this.sub = this.route.params.subscribe(params => {
      console.log(params)
      this.currentCat = +params['cat']; // (+) converts string 'id' to a number

      this.api.getCategoryPos(this.currentCat).subscribe(
      val => {
        console.log(val.json());
        this.currentCatID = val.json().data._id;
        if (this.dataComponent.titleCategory === '') {
          this.dataComponent.titleCategory = val.json().data.cat_name;
        }
        this.typeCat = val.json().data.cat_type;

      },
      error => {
        // console.log(error);
      },
      () => {

          this.api.getList(this.currentCatID).subscribe(
            val => {
              // console.log(val.json())

              // console.log(val.json());
              if (val.json().status === 1) {

                this.listArray = val.json().data;

                for (let i = 0; i < this.listArray.length; i++) {
                  this.listArray[i].characters =  this.listArray[i].name.length;

                  if(this.listArray[i].show === true){
                    let objCity = this.dataCity.find(x => x === this.listArray[i].location);
  
                    if (objCity === undefined) {
                      this.dataCity.push(this.listArray[i].location);
                      this.dataCity.sort().reverse();
                    }
                  }

                }
              }
            },
            error => {},

            () => {
              this.pagingList = this.listArray;

              // console.log(this.currentCat);

              if (this.typeCat === 1){
                this.pagingList.sort(this.dynamicSort("name"));
              }
              this.pagingList.sort(this.dynamicSort("name"));//temp


              console.log(this.pagingList);

              // for (let i = 0; i < this.dataCity.length; i++) {
              //   let findIndex = this.tempArraySubmit.findIndex(
              //     e =>
              //       e.location === this.dataCity[i] &&
              //       e.category === this.currentCatID
              //   );

              //   if (findIndex >= 0) {
              //     let findIndexList = this.listArray.findIndex(e => e.location === this.dataCity[i] && e.category === this.currentCat && e.id === this.tempArraySubmit[findIndex].id);
              //     if (findIndexList >= 0) {
              //       this.listArray[findIndexList].status = true;
              //     }
              //   }

              // }

              if(this.tempArraySubmit.length>0){
                for (let i = 0; i < this.tempArraySubmit.length; i++) {
                  let findIndexList = this.listArray.findIndex(e => e._id === this.tempArraySubmit[i]._id);
                    if (findIndexList >= 0) {
                      this.listArray[findIndexList].status = true;
                    }
                }
              }

              this.api.getAds(this.currentCatID).subscribe(
                val => {
                  console.log(val.json())

                  // console.log(val.json());
                  if (val.json().status === 1) {

                    this.listArrayAds = val.json().data;

                    for (let i = 0; i < this.listArrayAds.length; i++) {
                      // this.listArrayAds[i].characters = this.listArrayAds[i].name.length;

                      if (this.listArrayAds[i].show === true) {
                        let objCity = this.dataCity.find(x => x === this.listArrayAds[i].location);

                        if (objCity === undefined) {
                          this.dataCity.push(this.listArrayAds[i].location);
                          this.dataCity.sort().reverse();
                        }
                      }

                    }
                  }
                },
                error => { },

                () => {
                  this.pagingAds = this.listArrayAds;
                }
              )

            }
          );

      });

    });

  }
  

  submitVote() {
    // console.log(this.dataComponent.dataTemp);
    if (this.tempArraySubmit.length > 0) {
      this.router.navigate(['finish']);
    } else {
      this.snackBar.open('Please Complete The Voting', 'OK', {
        duration: 5000,
      }).onAction();
    }
    // this.dataComponent.dataTemp = this.tempArraySubmit;

    // let countCategoryCity = 0;

    // this.tempArrayPaging = [];

    // for (let i = 0; i < this.pagingList.length; i++) {
    //     countCategoryCity = countCategoryCity + _.keys(this.pagingList[i].location).length;
    // }

    // if (countCategoryCity === this.currentSelected && this.tempArraySubmit.length === 36) {
    //     this.router.navigate(['finish']);
    //     this.currentSelected = 0;

    // } else if (this.tempArraySubmit.length !== 36 - countCategoryCity) {

    //     this.snackBar.open('Please Complete The Voting', 'OK', {
    //         duration: 10000,
    //     }).onAction().subscribe(
    //         () => {
    //             this.currentSelected = 0;
    //             this.router.navigate(['reader', 2018, 1]);
    //         });
    // } else {
    //     this.snackBar.open('Please Try Again.', 'OK', {
    //         duration: 10000,
    //     }).onAction().subscribe(
    //         () => {
    //             //console.log('OKAY');
    //         });
    // }

  }

  objectKeys(id) {
    let totalVote: any;
    totalVote = this.listTotalVoter[id].total_voter;
    return totalVote;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  // doneVote() {

  //   if ( this.tempArraySubmit.length > 0) {
  //     this.dataComponent.dataTemp = this.tempArraySubmit;
  //     this.router.navigate(['dashboard', 2019]);

  //   } else {
  //     this.snackBar.open('Please Try Again.', 'OK', {
  //       duration: 5000,
  //     }).onAction().subscribe(
  //       () => {
  //         //console.log('OKAY');
  //       });
  //   }

  //   // console.log(this.dataComponent.dataTemp);

  // }

  backVote(){
    this.router.navigate(['dashboard', 2021]);
  }

  checkboxChange(checked:any, data:any, index:any){
    if(checked){
      this.tempArraySubmit.push(data);
      this.listArray[index].status = true;
    } else {
      let findIndexB = this.tempArraySubmit.findIndex(e => e._id === data._id);
      console.log(findIndexB)
      if (findIndexB >= 0) {
        this.tempArraySubmit.splice(findIndexB, 1);
        this.listArray[index].status = false;
      }
    }
    // console.log(this.tempArraySubmit);
  }

  selectNominee(lists: any, index: any) {

    if (this.currentTime <= this.expCounter) {
      let findIndex = this.tempArraySubmit.findIndex(
        e =>
        e.location === lists.location &&
        e.category === lists.category
      );
  
      if (findIndex < 0 ) {
        this.tempArraySubmit.push(lists);
        this.listArray[index].status = true;
      } else {
        let findCheckedIndex = this.listArray.findIndex(e => e.location === lists.location && e.category === lists.category && e.status === true);
        if (findCheckedIndex >= 0) {
          let findIndexB = this.tempArraySubmit.findIndex( e => e.location === lists.location && e.category === lists.category);
          if (findIndexB >= 0) {
            this.listArray[findCheckedIndex].status = false;
            this.tempArraySubmit.splice(findIndexB, 1);
            this.tempArraySubmit.push(lists);
            this.listArray[index].status = true;
          }
        }
      }
  
  
    // console.log(this.tempArraySubmit);
    }

  }

}
